import {
    SET_MODE
  } from 'shared/constants/ActionTypes';
  
  export const setModeApp = (mode) => {
    return (dispatch) => dispatch({type: SET_MODE, payload: mode});
  };
  